import React from 'react';

import PropTypes from 'prop-types';

import styles from './CalendarFooter.scss';

const CalendarFooter = ({ onClick, today }) => {
    return (
        <span className={styles.container} onClick={onClick}>
            {today}
        </span>
    );
};

CalendarFooter.propTypes = {
    today: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

CalendarFooter.defaultProps = {
    today: 'Today',
};

export default CalendarFooter;
